<script lang="ts">
	import Icon from "../../lib/Icon.svelte";
	import UserIcon from "../../lib/UserIcon.svelte";

	import { uid } from "@xbs/lib-state";
	import type { ICard, ICardShape } from "@xbs/lib-kanban";
	import { dateToString } from "@xbs/lib-core-dom";
	import { getContext } from "svelte";
	export let cardFields: ICard;
	export let cardShape: ICardShape;

	type TFooterValues = {
		users?: ICardShape["users"]["values"];
		endDate?: string;
		startDate?: string;
		attached?: number;
	};

	const lang = getContext<any>("wx-i18n");
	const defaultFormat = "%M %d";

	function getFooterValues(
		cardFields: ICard,
		shape: ICardShape
	): TFooterValues {
		let values = {} as TFooterValues;

		const { show } = shape?.users || {};
		const usersIds = cardFields.users;

		if (show && usersIds) {
			const usersConfig = usersIds.reduce((c, id) => {
				const user = shape.users.values?.find(v => v.id === id);
				if (user) {
					c.push(user);
				}
				return c;
			}, []) as ICardShape["users"]["values"];

			let users = usersConfig.map(user => {
				let label = user.label || "";
				return { ...user, label, id: user.id || uid() };
			});
			const maxUsersCount = 2;
			if (usersConfig.length > maxUsersCount) {
				users = users.splice(0, maxUsersCount);
				users.push({
					label: `+${usersConfig.length - users.length}`,
					id: "$total",
				});
			}
			if (users?.length) {
				values.users = users;
			}
		}
		const { show: showStartDate, format: startFormat } =
			shape.start_date || {};
		const { show: showEndDate, format: endFormat } = shape.end_date || {};

		let { end_date, start_date } = cardFields;

		if (showStartDate || showEndDate) {
			if (start_date) {
				values.startDate = dateToString(
					startFormat || defaultFormat,
					lang.getRaw().calendar
				)(start_date as Date);
			}
			if (end_date) {
				values.endDate = dateToString(
					endFormat || defaultFormat,
					lang.getRaw().calendar
				)(end_date as Date);
			}
		}

		if (shape?.attached?.show && cardFields.attached?.length) {
			values.attached = cardFields.attached.length;
		}
		return values;
	}
	$: footerValues = getFooterValues(cardFields, cardShape);

</script>

<div
	class="wx-footer"
	class:wx-with-content={!!Object.keys(footerValues).length}>
	<div class="wx-users">
		{#if footerValues.users}
			{#each footerValues.users as user (user.id)}
				<UserIcon data={user} noTransform={user.id === '$total'} />
			{/each}
		{/if}
	</div>
	{#if footerValues.attached}
		<div class="wx-attached">
			<Icon name="wxi-paperclip" />
			{footerValues.attached}
		</div>
	{/if}
	{#if footerValues.endDate || footerValues.startDate}
		<div class="wx-date">
			<Icon name="wxi-calendar" />
			{#if footerValues.startDate}
				<span class="wx-date-value">{footerValues.startDate}</span>
			{/if}
			{#if footerValues.endDate && footerValues.startDate}-{/if}
			{#if footerValues.endDate}
				<span class="wx-date-value">{footerValues.endDate}</span>
			{/if}
		</div>
	{/if}
</div>

<style>
	.wx-footer {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	.wx-with-content {
		padding-top: var(--wx-kanban-card-field-padding);
	}
	.wx-users {
		display: flex;
	}
	.wx-date {
		display: flex;
		align-items: center;
	}
	.wx-date-value {
		padding: 0 5px;
	}

	.wx-attached {
		display: flex;
		align-items: center;
	}

</style>
